import styled, { css } from 'styled-components';

export const BuyNowContainer = styled.div`
    position: ${(props) => (props.isFixed ? 'fixed' : 'static')};
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background-color: #ef4e5e;
    margin: ${(props) => (props.isFixed ? '' : '0 12px')};
    border-radius: ${(props) => (props.isFixed ? '' : '6px')};
    padding: ${(props) => (props.lactoMama && !props.isFixed ? '0px 100px' : '')};

    p{
        padding: 16px 0px;
        color: rgba(255, 255, 255);
        text-align: center;
        font-weight: 500;
    }

    ${(props) =>
      props.showNewAddToCartButton &&
      css`
        background: #fff;
        border-top: 2px solid rgba(0, 0, 0, 0.12);

        .BuyNowLactomama {
          display: flex;
          align-items: center;

          .savings {
            color: rgba(0, 0, 0, 0.8);
            display: flex;
            flex-direction: column;
            justify-content: center;
            text-align: left;
            line-height: 1.2;
            margin: 2px 12px;

            p {
              font-size: 16px;
              font-weight: 600;
              color: rgba(0, 0, 0, 0.7);
              span {
                font-size: 16px;
              }
              padding: 0px !important;
            }

            .priceFlex {
              display: flex;
              align-items: center;
              margin: 2px 0 5px 0;
              gap: 7px;

              .moreVarients {
                font-size: 10px;
                font-weight: 500;
                color: #ef4e5e;
              }

              .inclTaxes {
                font-size: 9px;
                color: rgba(0, 0, 0, 0.6);
                font-weight: 500;
                margin-bottom: 4px;
              }
            }

            .beforeAndAfterPrices {
              display: flex;
              align-items: center;
              gap: 7px;
              margin: 5px 0;
              .strikeprice {
                color: rgba(0, 0, 0, 0.38);
                font-size: 13px;
                font-weight: 400;
                text-decoration: line-through;
                text-align: left;
              }
            }

            .discount {
              color: #fff;
              border: 1px solid #61ada5;
              border-radius: 5px;
              padding: 2px 5px;
              background: #61ada5;
              font-size: 9px;
              font-weight: 500;
            }
          }
          button {
            background: #ef4e5e;
            color: #fff;
            border: #ef4e5e;
            border-radius: 8px;
            position: absolute;
            right: 0;
            height: 42px;
            font-size: 15px;
            font-weight: 600;
            text-align: center;
            margin: 2px 12px;
            width: 50%;
            font-family: 'Montserrat';
            cursor: pointer;
          }
        }
      `}

@media(min - width: 720px) {
    width: ${(props) => (props.lactoMama ? '100%' : '')};
    z - index: ${(props) => (props.lactoMama ? '98' : '1000')};
        p{
        padding: 16px 0px;
        color: rgb(255, 255, 255);
        text - align: center;
        font - weight: 500;
    }
}
`;

export const OfferStrip = styled.div`
  background: #ecffe8;
  height: 24px;
  width: 100%;
  position: fixed;
  bottom: 53px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 1000;

  span {
    font-size: 10px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.6);
    position: absolute;
    white-space: nowrap;

    &.offer-transition {
      display: block;
      animation: ${(props) =>
        props.offers > 1 ? 'fadeSlideOut 3s ease-in-out' : 'none'};
      animation-fill-mode: ${(props) =>
        props.offers > 1 ? 'forwards' : 'none'};
    }
  }
  @keyframes fadeSlideOut {
    0% {
      opacity: 0;
      transform: translateX(20px);
    }
    10%,
    90% {
      opacity: 1;
      transform: translateX(0);
    }
    100% {
      opacity: 0;
      transform: translateX(-20px);
    }
  }
`;
